<template>
    <slide-x-left-transition :duration="400+(index*100)" :delay="200+(index*100)">
        <ion-card v-if="show" mode="ios" style="margin: 0 0 20px 0px">
            <ion-item>
                <ion-thumbnail slot="start" style="width: 65px; height: 65px; padding: 15px 0">
                    <img v-if="image" :src="image" style="width: 100%; height: auto"/>
                    <ion-skeleton-text v-else animated></ion-skeleton-text>
                </ion-thumbnail>
                <ion-label mode="md" class="ion-text-wrap">
                    <h3>{{ name }}</h3>
                    <p>{{ city_name }} {{ zip_code }}</p>
                    <p>ul. {{ street }}</p>
                </ion-label>
            </ion-item>
            <ion-card-content>
                <ion-row>
                    <ion-col>
                        <p style="margin-top: 10px" v-if="ebi"><strong>SFA:</strong> {{ ebi }}</p>
                    </ion-col>
                    <ion-col class="text-right">
                        <ion-button mode="ios"
                                    fill="outline"
                                    size="small"
                                    @click="goTo('UserPlacesDetail', facility_slug, 'Edytuj lokal', place_slug)"
                                    style="margin-top: 6px">Edytuj lokal
                        </ion-button>
                    </ion-col>
                </ion-row>
            </ion-card-content>
        </ion-card>
    </slide-x-left-transition>
</template>

<script>
    import goTo from '@/mixins/goto';

    export default {
        name: 'ItemUserPlace',
        props: ['index', 'facility_slug', 'place_slug', 'city_name', 'ebi', 'name', 'street', 'tax_id', 'zip_code','image'],
        mixins: [goTo],
        data() {
            return {
                show: false
            }
        },
        mounted() {
            this.show = true;
        }
    }
</script>


<style lang="scss" scoped>
    ion-card-content{
        padding: 6px 12px;
        background: #ffffff;
    }
</style>